import React, { useState, useEffect,useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { END_URL, IMG_URL } from "../../config";
import Dashboard from "../Dashboard/Dashboard";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import "../DeepDrive/DeepDrive.css";

import gg from "../../../src/images/pp-logo.gif"

function ViewAttempt({ globaltest }) {
  const { attemptId } = useParams();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("N");
  const [attemptData, setAttemptData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [BannerContent, setBannerContent] = useState({});
  const [attemptDate, setAttemptDate] = useState("");
  const deepFluidRef = useRef(null);
  const tabs = ["N", "A", "C", "H", "O"];

  const currentTabIndex = tabs.indexOf(activeTab);

  useEffect(() => {
    const fetchAttemptData = async () => {
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("User not authenticated");
        navigate("/login");
        return;
      }

      try {
        // Fetch specific attempt details
        const response = await axios.get(
          `${END_URL}/user-answers/attempt/${attemptId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        setAttemptData(response.data.deep_answers || []);
        setAttemptDate(response.data.attempt_date || "");
        setBannerContent(response.data.banner_content || {});
        setLoading(false);
      } catch (error) {
        console.error("Error fetching attempt data:", error);
        setLoading(false);
      }
    };

    fetchAttemptData();
    window.scrollTo(0, 0);
  }, [attemptId, navigate]);

  const getTabLabel = (tab) => {
    const labels = {
      N: "Natural Gifts",
      A: "Areas to Improve",
      C: "Chances",
      H: "Hurdles",
      O: "Outcomes",
    };
    const count = attemptData.filter((item) => item.type === tab).length;
    return `${labels[tab]} (${count})`;
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };


   const handleNextClick = () => {

    if (currentTabIndex < tabs.length - 1) {
      setActiveTab(tabs[currentTabIndex + 1]);
      setTimeout(() => {
        if (deepFluidRef.current) {
          deepFluidRef.current.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }, 100);
    }
  };

  const handlePrevClick = () => {
    if (currentTabIndex > 0) {
      setActiveTab(tabs[currentTabIndex - 1]);

      setTimeout(() => {
        if (deepFluidRef.current) {
          deepFluidRef.current.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }, 100);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const filteredData = attemptData.filter((item) => item.type === activeTab);

  return (
    <div className="deep-main">

      
      {loading ? (

          
          <div className="loadingDiv">
                         <img
                      src={gg}
                      alt="Loading..."

                    />
            </div>

        ) : (
            <>

            <div className="container-fluid">

              <div className="row ques-row">
                <div className="col-12 col-sm-12 col-md-12">
                  <div
                    className="ques-top"
                    style={{
                      background: `url(${IMG_URL}/d0/${BannerContent?.deep_drive_banner_image}) no-repeat center center`,
                      backgroundSize: "cover",
                    }}
                  >


                    <div className="ques-top-title" dangerouslySetInnerHTML={{ __html:BannerContent?.deep_drive_detail_content }} />

                  </div>
                </div>
              </div>
            </div>

          <div className="container-fluid deep-fluid" ref={deepFluidRef} >
            <div className="row" style={{ marginBottom: "20px" }}>
         
            </div>

            <div className="row deep-sec-row">

              <div className="col-12 col-sm-12 col-md-3 col-lg-3 das-res">

                    <Dashboard globaltest={globaltest} />

              </div>

              <div className="col-12 col-sm-12 col-md-8 deep-tab">
                <div className="deep-inner-outer">
                  {loading ? (
                    <div className="alert alert-info">Loading attempt details...</div>
                  ) : attemptData.length === 0 ? (
                    <div className="alert alert-warning">
                      No data found for this attempt.
                    </div>
                  ) : (
                    <>
                      <div className="deep-tab-lists">
                        <ul>
                          {["N", "A", "C", "H", "O"].map((tab) => (
                            <li
                              key={tab}
                              onClick={() => handleTabClick(tab)}
                              className={activeTab === tab ? "active" : ""}
                            >
                              <span>{tab}</span>
                              <span>{getTabLabel(tab)}</span>
                            </li>
                          ))}
                        </ul>
                      </div>

                      <div className="deep-contents">
                        {filteredData.map((item, index) => (
                          <div key={index} className="deep-ip-divs">
                            <label
                              dangerouslySetInnerHTML={{ __html: item.questions }}
                            />
                            <div
                              className="view-answer-box"
                              style={{
                                padding: "15px",
                                backgroundColor: "#f8f9fa",
                                border: "1px solid #dee2e6",
                                borderRadius: "5px",
                                minHeight: "80px",
                                whiteSpace: "pre-wrap",
                                wordBreak: "break-word",
                              }}
                            >
                              {item.answers || "No answer provided"}
                            </div>
                          </div>
                        ))}
                      </div>

                      <div className="ques-btn">
                        <div
                            className={`nav-head-out-btn11 ${
                              currentTabIndex > 0 ? "combine-btns-q" : ""
                            }`}
                        >
                          {currentTabIndex > 0 && (
                            <button
                              className="nav-head-out-btn-text"
                              onClick={handlePrevClick}
                            >
                              <span className="nav-head-out-btn-icon">
                                <svg
                                  aria-hidden="true"
                                  focusable="false"
                                  data-prefix="fas"
                                  data-icon="arrow-left"
                                  className="svg-inline--fa fa-arrow-left"
                                  role="img"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 448 512"
                                >
                                  <path
                                    fill="currentColor"
                                    d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 256H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H109.3L214.6 78.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"
                                  />
                                </svg>
                              </span>
                              {BannerContent?.pesonality_previous_btn}
                            </button>
                          )}
        
                          {currentTabIndex < tabs.length - 1 && (
                      
                              <button
                                className="nav-head-out-btn-text"
                                onClick={handleNextClick}
                              >
                                {BannerContent?.pesonality_next_btn}
        
                                <span className="nav-head-out-btn-icon">
                                  <svg
                                    aria-hidden="true"
                                    focusable="false"
                                    data-prefix="fas"
                                    data-icon="arrow-right"
                                    className="svg-inline--fa fa-arrow-right"
                                    role="img"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 448 512"
                                  >
                                    <path
                                      fill="currentColor"
                                      d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"
                                    />
                                  </svg>
                                </span>
                              </button>
                          ) }
                          
                        </div>
                      </div>

                    </>
                  )}
                </div>
              </div>
            </div>

          </div>
          </>
        )}

    </div>
  );
}

export default ViewAttempt;